const isUndefined = function(value: any): value is undefined {
  return value === undefined;
};

export default isUndefined;
